<template>
  <select 
    v-model.number="activeTill"
    class="form-control c-select">
    <option value="0">All Till Number</option>
    <option 
      v-for="till in tillList" 
      :value="till.id" 
      :key="till.id">{{ till.sequence_number }}</option>
  </select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        till: {
            type: Number,
            default: 0,
        },

        day_operation_id: {
            type: String,
            required: true,
        },
    },

    computed: {
        activeTill: {
            get() {
                return this.$store.getters.activeTill;
            },

            set(value) {
                this.$store.commit('setActiveTill', value);
            },
        },

        ...mapGetters(['tillList']),
    },

    mounted() {
        this.tillListEvent();
    },

    methods: {
        ...mapActions(['getTillList']),

        tillListEvent() {
            this.getTillList(this.day_operation_id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TillSelector.vue